import { FC, useEffect } from 'react';
import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import { IModalComponentProps } from '@context/modal_context';
import VerificationCode from '@components/verification_code';

const UpdatePinModal: FC<IModalComponentProps<{ pin: string }>> = ({
    changeModalData,
    modalData,
    handleChangeDisable
}) => {
    const { t } = useTranslation('modals', {
        keyPrefix: 'update_pin'
    });

    useEffect(() => {
        if (modalData?.pin && modalData.pin.length === 4) {
            handleChangeDisable(false);
        } else {
            handleChangeDisable(true);
        }
    }, [modalData]);

    return (
        <div className={styles.wrapper}>
            <Typography className={styles.title} variant="h4">
                {t('title')}
            </Typography>
            <div className={styles.inputs_wrapper}>
                <div className={styles.input_wrapper}>
                    <VerificationCode
                        value={modalData?.pin}
                        onChange={(val) => changeModalData({ ...modalData, pin: val })}
                        lengthCount={4}
                    />
                </div>
            </div>
        </div>
    );
};

export default UpdatePinModal;
